module.exports = function() {
  return new Worker(__webpack_public_path__ + "6adb3bb27b4bdb2b6b8e.worker.js");
};